import { createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';
import _ from 'lodash';
import ThemeActions from './theme-actions';

const initialState = Immutable({ byId: {} });

// WYN-5807 we now integrate themes to the byId state
// use clearThemes first if you want a clean list to start with
// use selectors.themeById to select specific themes by id
const reducer = createReducer((on) => {
  on(ThemeActions.fetchThemesSuccess, (state, { themes }) => {
    const _themesById = _.reduce(
      themes,
      (acc, theme) => {
        acc[theme.id] = theme;
        return acc;
      },
      {}
    );

    const themesById = state.byId.merge(_themesById);
    return state.set('byId', themesById);
  });

  //this action is similar to the one above , but this one specifically
  //sets the theme list, and does not merge
  //this is to avoid regression issues
  on(ThemeActions.setThemeList, (state, { themes }) => {
    const _themesById = _.reduce(
      themes,
      (acc, theme) => {
        acc[theme.id] = theme;
        return acc;
      },
      {}
    );

    return state.set('byId', _themesById);
  });

  on(ThemeActions.clearThemes, (state) => {
    return state.set('byId', {});
  });

  on(ThemeActions.fetchThemeSuccess, (state, { theme }) => {
    return state.setIn(['byId', theme.id], theme);
  });
}, initialState);

export default reducer;
